import React, { useState, useEffect } from 'react';
import ApiService from 'services/ApiService';
import '../../css/dsrcRawData.css'

const DsrcRawData = () => {
    const today = new Date().toISOString().split('T')[0]; 
    const [selectedDate, setSelectedDate] = useState(today);
    const [dsrcData, setDsrcData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const timeColumns = Array.from({ length: 24 }, (_, i) =>
        `${i.toString().padStart(2, '0')}시`
    );

    // API 호출 함수
    const fetchDsrcData = async (date) => {
        setLoading(true);
        setError(null);
        setDsrcData([]);

        try {
            const formattedDate = date.replace(/-/g, '');
            const response = await ApiService.get(`newdashboard/afterpack/GetDsrcTrf?dtm=${formattedDate}`);
            console.log('response :::',response)
            if (response.data && Array.isArray(response.data)) {
                setDsrcData(response.data);
            } else {
                setError('데이터를 불러올 수 없습니다.');
                setDsrcData([]); 
            }
        } catch (err) {
            console.error('DSRC 데이터 조회 오류:', err);
            setError('데이터 조회 중 오류가 발생했습니다.');
            setDsrcData([]); 
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDsrcData(selectedDate);
    }, [selectedDate]);


    const handleDateChange = (e) => {
        const newDate = e.target.value;

        if (newDate !== selectedDate) {
            setSelectedDate(newDate);
            setError(null);
        }
    };

    // 특정 시간의 데이터 값 찾기
    const getHourValue = (rows, hour) => {
        if (!rows || !Array.isArray(rows)) return '0';

        const hourStr = hour.toString().padStart(2, '0');
        const hourData = rows.find(row => row.hh === hourStr);

        if (hourData) {
            return hourData.value !== null ? hourData.value : '0';
        }
        return '0';
    };

    // 시간대별 데이터 렌더링 함수
    const renderHourlyData = (item) => {
        return Array.from({ length: 24 }, (_, index) => {
            const value = getHourValue(item.rows, index);
            return (
                <td key={`hour-${index}`}>
                    {value}
                </td>
            );
        });
    };

const renderTable = () => {
    if (loading) {
        return (
            <div className="table-loading">
                <div className="loading-spinner"></div>
                <div>데이터를 불러오는 중...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="table-error">
                <div>{error}</div>
                <button
                    onClick={() => fetchDsrcData(selectedDate)}
                    className="retry-button"
                >
                    다시 시도
                </button>
            </div>
        );
    }

    return (
        <div className="dsrc-table-wrapper">
            <table className="dsrc-table">
                <thead>
                    <tr>
                        <th className="fixed-column rse-id">RSE ID</th>
                        <th className="fixed-column station-name-header">RSE 명칭</th>
                        {timeColumns.map((time, index) => (
                            <th key={`header-${index}`} className="time-column">
                                {time}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dsrcData && dsrcData.length > 0 ? (
                        dsrcData.map((item, index) => (
                            <tr key={`row-${selectedDate}-${index}`}>
                                <td className="fixed-column rse-id">
                                    {item.info?.sectId || `ID-${index}`}
                                </td>
                                <td className="fixed-column station-name">
                                    <div className="road-name">{item.info?.roadNm || '도로명'}</div>
                                    {/* {item.info?.startNm && item.info?.endNm && (
                                        <div className="station-detail">
                                            {item.info.startNm} → {item.info.endNm}
                                        </div>
                                    )} */}
                                </td>
                                {renderHourlyData(item)}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={timeColumns.length + 2} className="no-data">
                                조회된 데이터가 없습니다.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

return (
    <div className="dsrc-container">
        <div className="dsrc-header">
            <h1>DSRC 원시데이터 조회</h1>
            <div className="date-selector">
                <label>조회일시</label>
                <input
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    className="date-input"
                    disabled={loading}
                />
            </div>
        </div>
        {renderTable()}
    </div>
);
};

export default DsrcRawData;